import { Show, createSignal } from "solid-js";
import { css } from "styled-system/css";
import Motif from "./Motif";

export default function Thumbnail(props: { seed: string; color: string; thumbnailUrl?: string | null }) {
  const [errored, setErrored] = createSignal(false);

  return (
    <Show when={props.thumbnailUrl && !errored()} fallback={<Motif seed={props.seed} color={props.color} />}>
      <img
        src={props.thumbnailUrl ?? undefined}
        onError={() => setErrored(true)}
        class={css({ w: 'full', h: 'full', objectFit: 'cover' })}
      />
    </Show>
  );
}
